import { useMantineColorScheme, useComputedColorScheme } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export function ThemeSelector() {
  const { t } = useTranslation();
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light');

  const toggleColorScheme = () => {
    setColorScheme(computedColorScheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <button
      type="button"
      className="header-theme-toggle-button"
      onClick={toggleColorScheme}
      aria-label={t('theme.toggle')}
    >
      {computedColorScheme === 'dark' ? (
        <IconSun size={18} stroke={2} />
      ) : (
        <IconMoon size={18} stroke={2} />
      )}
    </button>
  );
}
